import React, { memo } from 'react';
import { cookRecentlyViewedAccountsForSelectors } from '@signal/core/local';
import { cookActiveAccountForSelectors } from '@signal/core/auth';
import { useContextsInReduxForm } from '@signal/core/contextFetch/hooks';
import { cookUserAccountsForSelectors } from '@signal/core/user';
import { ActiveAccountContext, UserAccountsContext } from '@signal/core/user/Context';
import Typography from '../Typography';
import { recentlyViewAccountsSelector } from './selectors';
import { Wrapper, Title, Recents, RecentAccount } from './styles';
var REDUX_COOKERS = [{
  context: ActiveAccountContext,
  cookers: [cookActiveAccountForSelectors, cookRecentlyViewedAccountsForSelectors]
}, {
  context: UserAccountsContext,
  cookers: [cookUserAccountsForSelectors]
}];
export function RecentAccountsList(_ref) {
  var onAccountChange = _ref.onAccountChange;
  var selectorState = useContextsInReduxForm(REDUX_COOKERS);
  var accounts = recentlyViewAccountsSelector(selectorState);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Title, null, "Recently Viewed Accounts"), /*#__PURE__*/React.createElement(Recents, {
    component: "nav"
  }, accounts.map(function (account) {
    return /*#__PURE__*/React.createElement(RecentAccount, {
      key: account.accountId,
      onClick: onAccountChange(account)
    }, /*#__PURE__*/React.createElement(Typography, {
      component: "span"
    }, account.name));
  })));
}
export default /*#__PURE__*/memo(RecentAccountsList);